import { createCustomSlice } from 'core/utils';

const initialState = {
    list: [],
    status: '',
    videoconference: {}
};

const videoconferenceSlice = createCustomSlice({
    initialState,
    name: 'videoconference',
    reducers: {},
    saga: [
        'createVideoconference',
        'deleteVideoconference',
        'editVideoconference',
        'getVideoconference',
        'getVideoconferenceList'
    ]
});

export const videoconferenceActions = videoconferenceSlice.actions;

export default videoconferenceSlice.reducer;
